<template>
    <div class="row">
        <div class="col-md-12 ml-auto mr-auto" v-if="isValid('CreditInvoices') || isValid('CashInvoices') || isValid('CanHoldInvoices') || isValid('CanEditHoldInvoices')" v-bind:style="$i18n.locale == 'ar' ? languageChange('en') : languageChange('ar')">
            <div class="row" v-if="isDayAlreadyStart">
                <div class="col-lg-12 top_auto_no" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? '' : 'top_auto_no_ar'">
                    <span v-if="!sale.isCredit">({{autoNumber}})</span> {{sale.date}}
                </div>
            </div>
            <div class="row mt-3" v-if="isDayAlreadyStart">
                <div class="col-lg-8">
                    <h5 class="banner_btm_pd" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? '' : 'banner_btm_pd_ar'" v-if="sale.id == '00000000-0000-0000-0000-000000000000'">
                        {{ $t('AddSale.InvoiceNo') }}
                        <span v-if="!sale.isCredit">{{sale.registrationNo}}</span>
                        <span v-if="sale.isCredit">{{autoNumberCredit}}</span>
                    </h5>
                    <h5 class="banner_btm_pd" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? '' : 'banner_btm_pd_ar'" v-else>
                        <span v-if="sale.isCredit">{{ $t('AddSale.AddSaleInvoice') }} {{autoNumberCredit}}</span>
                        <span v-else>{{ $t('AddSale.UpdateSaleInvoice') }} {{sale.registrationNo}}</span>
                    </h5>
                    <div class="card invoice_top_bg">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-lg-7" style="margin-bottom: auto; margin-top: auto;">
                                    <h5 class="text-white title_heading" v-bind:style="($i18n.locale == 'en' ||isLeftToRight()) ? '' : 'text-align: right !important;'">{{ $t('AddSale.AddSaleInvoice') }}</h5>
                                    <p class="text-white txt_description" v-bind:style="($i18n.locale == 'en' ||isLeftToRight()) ? '' : 'text-align: right !important;'">{{ $t('AddSale.invoiceDescription') }}</p>
                                </div>
                                <div class="col-lg-5 text-right">
                                    <img class="inv_main_img" src="/images/make-invoice1.png" alt="Alternate Text" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-2" v-bind:class="(sale.saleOrderId != '' &&  sale.saleOrderId != null) || onPayScreen ? 'pointer-event-remove' : '' ">
                    <div class="card payment_card">
                        <div class="card-body">
                            <div class="row pd_payment_methd">
                                <div class="col-lg-12 text-center">
                                    <img class="payment_card_img" src="/images/walletpayment.png" alt="Alternate Text" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12 mt-2">
                                    <p class="payment_method" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? '' : 'text-right'" style="margin-bottom: 0 !important;">{{ $t('AddSale.PaymentMethod') }}</p>
                                    <button v-if="isValid('CashInvoices')" v-on:click="isCredit(toggleCash)" type="button" v-bind:class="{ bt_bg_color: !sale.isCredit }" class="btn btn-outline-primary btn-block btn-sm payment_method_btn">{{ $t('AddSale.Cash') }} <img src="/images/Left_arrow2.png" v-bind:class="{ payment_method_btn_img: !sale.isCredit }" alt="Alternate Text" /> </button>
                                    <p v-else>Upgrade your package to unlock cash payment</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-2" v-bind:class="(sale.saleOrderId != '' &&  sale.saleOrderId != null) || onPayScreen ? 'pointer-event-remove' : '' ">
                    <div class="card payment_card">
                        <div class="card-body">
                            <div class="row pd_payment_methd">
                                <div class="col-lg-12 text-center">
                                    <img class="payment_card_img" src="/images/cardpayment.png" alt="Alternate Text" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12 mt-2">
                                    <p class="payment_method" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? '' : 'text-right'" style="margin-bottom: 0 !important;">{{ $t('AddSale.PaymentMethod') }}</p>
                                    <button v-if="isValid('CreditInvoices')" v-on:click="isCredit(toggleCredit)" type="button" v-bind:class="{ bt_bg_color: sale.isCredit }" class="btn btn-outline-primary btn-block btn-sm payment_method_btn">{{ $t('AddSale.Credit') }} <img src="/images/Left_arrow2.png" v-bind:class="{ payment_method_btn_img: sale.isCredit }" alt="Alternate Text" /> </button>
                                    <p v-else>Upgrade your package to unlock credit payment</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="accordion" role="tablist" v-if="isDayAlreadyStart">
                <b-card no-body class="mb-1" v-bind:style="($i18n.locale == 'en' ||isLeftToRight()) ? '' : 'direction: rtl'">
                    <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                        <b-card-body>

                            <div class="row" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? '' : 'arabicLanguage'">
                                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3" v-if="!sale.isCredit && isValid('CashInvoicesForWalkIn')" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                                    <label>{{ $t('AddSale.Walk-In') }} {{ $t('AddSale.Customer') }} :</label>
                                    <div v-bind:class="{'has-danger': $v.sale.cashCustomer.$error}">
                                        <input type="text" class="form-control" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'"
                                               :disabled="sale.customerId != '00000000-0000-0000-0000-000000000000' && sale.customerId != null"
                                               @focus="$event.target.select()"
                                               v-model="$v.sale.cashCustomer.$model" />
                                        <span v-if="$v.sale.cashCustomer.$error"
                                              class="error text-danger">
                                        </span>
                                    </div>
                                </div>

                                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3" v-if="!sale.isCredit" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                                    <label>{{ $t('AddSale.Mobile') }}  :</label>
                                    <div v-bind:class="{'has-danger': $v.sale.mobile.$error}">
                                        <input type="text" class="form-control" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'"
                                               v-model="$v.sale.mobile.$model" />
                                        <span v-if="$v.sale.mobile.$error"
                                              class="error text-danger">
                                        </span>
                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3" v-if="((isValid('CashInvoicesForCustomer') && paymentMethod == 'Cash') || (isValid('CreditInvoices')  && paymentMethod == 'Credit'))" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                                    <label>{{ $t('AddSale.Customer') }} :</label>
                                    <div v-bind:class="{'has-danger': $v.sale.customerId.$error}">
                                        <customerdropdown v-model="$v.sale.customerId.$model" :disable="sale.saleOrderId==null || sale.saleOrderId==''?false:true" :paymentTerm="paymentMethod" ref="CustomerDropdown" @input="emptyCashCustomer" v-on:input="getAddress" :values="sale.customerId" :key="customerRender" />
                                        <span v-if="$v.sale.customerId.$error"
                                              class="error text-danger">
                                        </span>
                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3" v-if="(sale.customerId!=null && sale.customerId!='00000000-0000-0000-0000-000000000000') || sale.isCredit" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                                    <label>{{ $t('AddSale.DueDate') }}  :</label>
                                    <div v-bind:class="{'has-danger': $v.sale.dueDate.$error}">
                                        <datepicker v-model="$v.sale.dueDate.$model" />

                                        <span v-if="$v.sale.dueDate.$error"
                                              class="error text-danger">
                                        </span>
                                    </div>
                                </div>

                                <div :class="{'col-xs-12 col-sm-6 col-md-6 col-lg-6':sale.isCredit, 'col-xs-12 col-sm-6 col-md-6 col-lg-3': !sale.isCredit}" v-if="isValid('CanSelectWarehouse')">
                                    <label style="width:100%;" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">{{ $t('AddSale.WareHouse') }} :<span class="LabelColour"> *</span></label>
                                    <warehouse-dropdown v-model="$v.sale.wareHouseId.$model" />
                                    <span v-if="$v.sale.wareHouseId.$error"
                                          class="error text-danger">
                                    </span>
                                </div>
                                <div :class="{'col-xs-12 col-sm-6 col-md-6 col-lg-6':sale.isCredit, 'col-xs-12 col-sm-6 col-md-6 col-lg-3': !sale.isCredit}" v-else>
                                    <label style="width:100%;" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">{{ $t('AddSale.WareHouse') }} :<span class="LabelColour"> *</span></label>
                                    <warehouse-dropdown :disable="true" v-model="$v.sale.wareHouseId.$model" />
                                    <span v-if="$v.sale.wareHouseId.$error"
                                          class="error text-danger">
                                    </span>
                                </div>
                                <!--<div class="col-xs-12 col-sm-6 col-md-6 col-lg-3" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
        <label>{{ $t('Sale.Employee') }}  :</label>
        <div>
            <employeeDropdown v-model="sale.employeeId" v-bind:values="sale.employeeId" />
        </div>
    </div>-->
                                <div v-if="!sale.isCredit && isValid('CashInvoicesForWalkIn')" class="col-xs-12 col-sm-6 col-md-6 col-lg-3" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                                    <label>{{ $t('AddSale.Search') }} :</label>
                                    <input :disabled="sale.customerId != '00000000-0000-0000-0000-000000000000' && sale.customerId != null"
                                           class="form-control"
                                           v-on:input="cashCustomerSearch(search)"
                                           v-model="search"
                                           v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" type="text" />
                                </div>
                                <div v-if="!sale.isCredit" class="col-xs-12 col-sm-6 col-md-6 col-lg-3" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                                    <label>{{ $t('AddSale.CustomerId') }} :</label>
                                    <input v-bind:disabled="sale.customerId != '00000000-0000-0000-0000-000000000000' && sale.customerId != null" class="form-control" v-model="sale.cashCustomerId" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" type="text" />
                                </div>
                                <div v-if="!sale.isCredit" class="col-xs-12 col-sm-6 col-md-6 col-lg-3" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                                    <label class="text  font-weight-bolder"> {{ $t('AddSale.RegisterUser_EmailID') }}:</label>
                                    <input v-bind:disabled="sale.customerId != '00000000-0000-0000-0000-000000000000' && sale.customerId != null" class="form-control" v-model="sale.email" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" type="text" />
                                </div>
                                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3" v-if="isValid('CreditInvoices') && (isValid('CanViewSaleOrder')|| isValid('CanAddSaleOrder'))">
                                    <label>{{ $t('AddSale.SaleOrder') }} :</label>
                                    <saleorderdropdown v-on:input="GetSaleOrderDetail(sale.saleOrderId)" v-model="sale.saleOrderId" :values="sale.saleOrderId" />
                                </div>


                                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3" v-if="saleOrder && (isValid('CanDraftQuotation') || isValid('CanViewQuotation'))">
                                    <label>{{ $t('Dashboard.Quotation') }} :</label>
                                    <quotationdropdown v-on:input="GetSaleOrderDetail(sale.quotationId)" v-model="sale.quotationId" :values="sale.quotationId" />
                                </div>

                                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3" v-if="isValid('CanSelectTransporter')">
                                    <label>  {{ $t('AddSale.Transporter/Cargo') }}  :</label>
                                    <logisticDropdown v-model="sale.logisticId" :values="sale.logisticId" v-bind:key="logisticRender" />
                                </div>

                                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" v-if="isArea=='true' && isValid('CanSelectArea')">
                                    <label>{{ $t('AddSale.Area') }}  :</label>
                                    <div>
                                        <areadropdown v-model="sale.areaId" v-bind:values="sale.areaId" />
                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" v-if="isRaw=='true' && isValid('CanSelectDispatchNote')">
                                    <label>{{ $t('AddSale.DispatchNote') }}  :</label>
                                    <div>
                                        <multiselect v-model="sale.dispatchNote" :options="options" :multiple="true" track-by="name"
                                                     :clear-on-select="false"
                                                     :show-labels="false"
                                                     label="name"
                                                     v-bind:placeholder="$t('AddSale.SelectOption')"
                                                     v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'"
                                                     :preselect-first="true"
                                                     v-on:input="GetDispatchNoteDetail(sale.dispatchNote, sale.dispatchNote.length)">
                                        </multiselect>

                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 pt-4 " >
                                    <span>
                                          <label class="text  font-weight-bolder">Is Warranty</label> :<toggle-button v-model="sale.isWarranty" class="pr-2 pl-2 pt-2" color="#3178F6" />

                                    </span>
                                </div>
                                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3" v-if="wholesalePriceActivation">
                                    <label class="typo__label">Select Price Type <span class="LabelColour"> *</span></label>
                                    <multiselect v-model="priceType" label="name" :options="priceoptions" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="Pick a value"></multiselect>
                                </div>
                                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3" v-if="isForMedical=='true'">
                                    <label>{{ $t('AddSale.DoctorName') }}  :</label>
                                    <input v-model="sale.doctorName" class="form-control" />
                                </div>
                                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3" v-if="isForMedical=='true'">
                                    <label>{{ $t('AddSale.HospitalName') }}  :</label>
                                    <input v-model="sale.hospitalName" class="form-control" />
                                </div> 
                                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3" >
                                    <label>PO Number  :</label>
                                    <input v-model="sale.poNumber" class="form-control" />
                                </div> 
                                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3" >
                                    <label>PO Date  :</label>
                                    <datepicker v-model="sale.poDate"  />
                                </div>

                                <div v-if="saleDefaultVat=='DefaultVatHead' || saleDefaultVat=='DefaultVatHeadItem'" class="col-xs-12 col-sm-6 col-md-6 col-lg-3" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                                    <label>{{ $t('AddPurchase.TaxMethod') }} :<span class="LabelColour"> *</span></label>
                                    <multiselect v-if="(this.$i18n.locale == 'en' || this.isLeftToRight())" :options="['Inclusive', 'Exclusive']" v-bind:disabled="sale.saleItems.length>0" v-model="sale.taxMethod" :show-labels="false" v-bind:placeholder="$t('AddStockValue.SelectMethod')" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                                    </multiselect>
                                    <multiselect v-else :options="['شامل', 'غير شامل']" v-bind:disabled="sale.saleItems.length>0" v-model="sale.taxMethod" :show-labels="false" v-bind:placeholder="$t('AddStockValue.SelectMethod')" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                                    </multiselect>
                                </div>
                                <div v-if="saleDefaultVat=='DefaultVatHead' || saleDefaultVat=='DefaultVatHeadItem'" class="col-xs-12 col-sm-6 col-md-6 col-lg-3" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                    <label>{{ $t('AddPurchase.VAT%') }} :<span class="LabelColour"> *</span></label>
                                    <taxratedropdown v-model="sale.taxRateId" v-bind:value="sale.taxRateId" :isDisable="sale.saleItems.length>0? true :false" :key="customerRender" />
                                </div>

                                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                                    <label>{{ $t('AddSale.CustomerAddress') }}  :</label>
                                    <textarea v-model="sale.customerAddressWalkIn" class="form-control"></textarea>
                                </div>
                            </div>

                            <br />
                            <sale-item :saleItems="sale.saleItems" ref="childComponentRef" :wareHouseId="sale.wareHouseId" :wholesale="priceType" :saleOrderId="sale.saleOrderId" @input="SaveSaleItems" @summary="updateSummary" :taxMethod="sale.taxMethod" :taxRateId="sale.taxRateId" />
                           
                            <div class="row  p-0 m-0"  v-if="sale.isCredit && isValid('CanPayInCredit')">
                                <div class="col-8 ">

                                </div>
                                <div class="col-4 text-right p-0">

                                    <table style="width:100%">
                                        <thead>
                                            <tr>
                                                <th class="text-left" style="width:60%;">Discount/Adjustment</th>
                                                <th class="text-right" style="width:40%;">Due Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td class="text-left">
                                                    <input v-model="sale.discount" :disabled="sale.salePayment.dueAmount > 0? false:true " class="form-control" type="number" />
                                                </td>
                                                <td class="text-right">
                                                    {{currency}} {{ parseFloat(parseFloat((sale.salePayment.dueAmount == '' || sale.salePayment.dueAmount == null)?0:sale.salePayment.dueAmount) - parseFloat((sale.discount == '' || sale.discount == null)?0:sale.discount)).toFixed(3).slice(0,-1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,") }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                
                            </div>
                            <div v-if="sale.isCredit && isValid('CanPayInCredit')" style="margin-top:12px">
                                <credit-payment :creditPaymentData="sale.paymentTypes" :totalDueAmount="sale.salePayment.dueAmount" v-on:input="getCreditAmount"></credit-payment>
                            </div>
                            <div v-if="!loading" class="col-md-12 arabicLanguage" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">

                                <button class="btn btn-primary mr-2 float-left" v-on:click="Attachment()">
                                    {{ $t('AddSale.Attachment') }}
                                </button>

                                <span v-if="sale.isCredit">
                                    <button class="btn btn-primary mr-2"
                                            v-if="isValid('CanHoldInvoices')"
                                            v-on:click="saveSale('Hold',false)"
                                            v-bind:disabled="$v.$invalid ||sale.salePayment.dueAmount < sale.discount || !isColorVariantsValid || sale.saleItems.filter(x => x.totalPiece=='').length > 0 || sale.saleItems.filter(x => x.unitPrice=='').length > 0">
                                        <span v-if="sale.id == '00000000-0000-0000-0000-000000000000'">
                                            {{ $t('AddSale.Hold') }}
                                        </span>
                                        <span v-if="sale.id != '00000000-0000-0000-0000-000000000000'">
                                            {{ $t('AddSale.HoldAndUpdate') }}
                                        </span>
                                    </button>
                                    <button class="btn btn-primary mr-2"
                                            v-if="isValid('CanHoldInvoices') && isValid('CanPrintInvoices')"
                                            v-on:click="saveSale('Hold',true)"
                                            v-bind:disabled="$v.$invalid ||sale.salePayment.dueAmount < sale.discount  || !isColorVariantsValid || sale.saleItems.filter(x => x.totalPiece=='').length > 0 || sale.saleItems.filter(x => x.unitPrice=='').length > 0">
                                        <span v-if="sale.id == '00000000-0000-0000-0000-000000000000'">
                                            {{ $t('AddSale.HoldAndPrint') }}
                                        </span>
                                        <span v-if="sale.id != '00000000-0000-0000-0000-000000000000'">
                                            {{ $t('AddSale.HoldAndPrint') }}
                                        </span>
                                    </button>

                                    <button class="btn btn-primary mr-2"
                                            v-on:click.once="saveSale('Credit',false)"
                                            v-if="isValid('CashInvoices')"
                                            v-bind:disabled="$v.$invalid ||sale.salePayment.dueAmount < sale.discount || (parseFloat(creditPayment) + parseFloat(sale.discount == ''?0:sale.discount))  > sale.salePayment.dueAmount || !isColorVariantsValid || sale.saleItems.filter(x => x.outOfStock).length > 0 || sale.saleItems.filter(x => x.totalPiece=='').length > 0 || sale.saleItems.filter(x => x.unitPrice=='').length > 0 || ( isFifo? (sale.saleItems.filter(x => x.expiryDate=='').length > 0 || sale.saleItems.filter(x => x.batchNo=='').length > 0):false)">
                                        <span>
                                            {{ $t('AddSale.SaveAndPost') }}
                                        </span>

                                    </button>
                                    <button class="btn btn-primary mr-2"
                                            v-on:click.once="saveSale('Credit',true)"
                                            v-if="isValid('CreditInvoices') && isValid('CanPrintInvoices')"
                                            v-bind:disabled="$v.$invalid ||sale.salePayment.dueAmount < sale.discount || (parseFloat(creditPayment) + parseFloat(sale.discount == ''?0:sale.discount)) > sale.salePayment.dueAmount  || !isColorVariantsValid || sale.saleItems.filter(x => x.outOfStock).length > 0 || sale.saleItems.filter(x => x.totalPiece=='').length > 0 || sale.saleItems.filter(x => x.unitPrice=='').length > 0 || ( isFifo? (sale.saleItems.filter(x => x.expiryDate=='').length > 0 || sale.saleItems.filter(x => x.batchNo=='').length > 0):false)">
                                        <span>
                                            {{ $t('AddSale.SaveasPostandPrint') }}

                                        </span>

                                    </button>
                                </span>
                                <span v-else>
                                    <button class="btn btn-success mr-2"
                                            v-on:click="OnEditInvoice()"
                                            block v-b-toggle.accordion-2 variant="info"
                                            v-bind:disabled="$v.$invalid || !isColorVariantsValid || sale.saleItems.filter(x => x.outOfStock).length > 0 || sale.saleItems.filter(x => x.totalPiece=='').length > 0 || sale.saleItems.filter(x => x.unitPrice=='').length > 0 || ( isFifo? (sale.saleItems.filter(x => x.expiryDate=='').length > 0 || sale.saleItems.filter(x => x.batchNo=='').length > 0):false)">
                                        {{ $t('AddSale.Pay') }}
                                    </button>

                                    <button class="btn btn-primary mr-2"
                                            v-if="isValid('CanHoldInvoices')"
                                            v-on:click.once="saveSale('Hold',false)"
                                            v-bind:disabled="$v.$invalid || !isColorVariantsValid || sale.saleItems.filter(x => x.totalPiece=='').length > 0 || sale.saleItems.filter(x => x.unitPrice=='').length > 0">
                                        <span v-if="sale.id == '00000000-0000-0000-0000-000000000000'">
                                            {{ $t('AddSale.Hold') }}
                                        </span>

                                        <span v-if="sale.id != '00000000-0000-0000-0000-000000000000'">
                                            {{ $t('AddSale.HoldAndUpdate') }}
                                        </span>

                                    </button>
                                    <button class="btn btn-primary mr-2"
                                            v-if="isValid('CanHoldInvoices') && isValid('CanPrintInvoices')"
                                            v-on:click.once="saveSale('Hold',true)"
                                            v-bind:disabled="$v.$invalid || !isColorVariantsValid || sale.saleItems.filter(x => x.totalPiece=='').length > 0 || sale.saleItems.filter(x => x.unitPrice=='').length > 0">
                                        <span v-if="sale.id == '00000000-0000-0000-0000-000000000000'">
                                            {{ $t('AddSale.HoldAndPrint') }}
                                        </span>

                                        <span v-if="sale.id != '00000000-0000-0000-0000-000000000000'">
                                            {{ $t('AddSale.HoldAndPrint') }}
                                        </span>
                                    </button>
                                </span>

                                <button class="btn btn-outline-danger mr-2"
                                        v-on:click="goToSale">
                                    {{ $t('AddSale.Cancel') }}
                                </button>
                            </div>
                            <div class="card-footer col-md-3 text-left" v-else>
                                <loading :name="loading" :active.sync="loading"
                                         :can-cancel="false"
                                         :is-full-page="true"></loading>
                            </div>
                        </b-card-body>
                    </b-collapse>
                </b-card>
                <b-card no-body class="mb-1">
                    <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                        <b-card-body v-bind:style="($i18n.locale == 'en' ||isLeftToRight()) ? '' : 'text-align: right'">
                            <h5>{{ $t('AddSale.Payment') }}</h5>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="card-body" style="background:#F1F6FF; height: 100%;">
                                        <div class="row">
                                            <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4" v-bind:style="($i18n.locale == 'en' ||isLeftToRight()) ? '' : 'direction: rtl'">
                                                <label>{{ $t('AddSale.PaymentType') }}:</label>
                                                <div v-on:click="isPayment(togglePayCash)" v-bind:class="{ bg_color: sale.salePayment.paymentType=='Cash' }" style="text-align: center; background-color: #dee9fe; height: 40px; padding: 10px; border-radius: 4px; font-size: 14px; cursor: pointer; width: 100%;"><i class="fas fa-money-bill-alt"></i> {{ $t('AddSale.Cash') }}</div>
                                            </div>
                                            <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4" v-bind:style="($i18n.locale == 'en' ||isLeftToRight()) ? '' : 'direction: rtl'">
                                                <label> &nbsp; </label>
                                                <div v-on:click="isPayment(toggleBank)" v-bind:class="{ bg_color: sale.salePayment.paymentType=='Bank' }" style="text-align: center; background-color: #dee9fe; height: 40px; padding: 10px; border-radius: 4px; font-size: 14px; cursor: pointer; width: 100%;"><i class="fas fa-money-bill-alt"></i> {{ $t('AddSale.Bank') }}</div>
                                            </div>
                                            <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4" v-bind:style="($i18n.locale == 'en' ||isLeftToRight()) ? '' : 'direction: rtl'">
                                                <label> &nbsp; </label>
                                                <div v-on:click="isPayment(toggleAdvance)" v-if="sale.customerId!=null" v-bind:class="{ bg_color: sale.salePayment.paymentType=='Advance' }" style="text-align: center; background-color: #dee9fe; height: 40px; padding: 10px; border-radius: 4px; font-size: 14px; cursor: pointer; width: 100%;"><i class="fas fa-money-bill-alt"></i> {{ $t('AddSale.Advance') }}</div>
                                                <div v-on:click="isPayment(toggleOtherCurrency)" v-if="sale.customerId==null" v-bind:class="{ bg_color: sale.salePayment.paymentType=='OtherCurrency' }" style="text-align: center; background-color: #dee9fe; height: 40px; padding: 10px; border-radius: 4px; font-size: 14px; cursor: pointer; width: 100%;"><i class="fas fa-money-bill-alt"></i> {{ $t('AddSale.OtherCurrency') }}</div>
                                            </div>
                                        </div>
                                        <div class="row mt-3" v-if="sale.salePayment.paymentType == 'Bank' && sale.customerId==null">
                                            <div class="col-lg-4 text-center mb-2" v-for="bank in bankList" v-bind:key="bank.id">
                                                <div v-bind:class="{ bg_color: bank.id==sale.salePayment.paymentOptionId }" v-on:click="selectBank(bank.id, bank.name)" style="background-color: #dee9fe; padding: 5px; border-radius: 4px; font-weight: 600; cursor: pointer;">
                                                    {{ bank.name }}
                                                    <img :src="'data:image/png;base64,' + bank.image" style="width: 35px; height: 20px;">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-3" v-if="sale.salePayment.paymentType == 'OtherCurrency'">
                                            <div class="col-lg-2 text-center" v-for="currency in currencyList" v-bind:key="currency.id">
                                                <div v-bind:class="{ bg_color: currency.id==sale.otherCurrency.currencyId }" v-on:click="selectCurrency(currency.id,currency.name)" style="background-color: #dee9fe; padding: 5px; border-radius: 4px; font-weight: 600; cursor: pointer;">
                                                    {{ currency.sign }}
                                                    <img src="Product.png" v-if="currency.image==null || currency.image=='' || currency.image==undefined" style="width: 90px; height: 40px;">
                                                    <img :src="'data:image/png;base64,' + currency.image" v-else style="width: 35px; height: 20px;">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-3">
                                                <h6>{{ $t('AddSale.Details') }} </h6>
                                                <div v-for="(payment, index) in sale.salePayment.paymentTypes" :key="index">
                                                    <p class="border-bottom mb-3">
                                                        <!--{{payment.paymentType}} : {{payment.amount | formatAmount}}-->
                                                        {{payment.name}} <span v-if="payment.paymentType=='OtherCurrency'">({{ $t('AddSale.Amount') }}={{payment.otherAmount}}, {{ $t('AddSale.Rate') }}={{payment.rate}})</span> : {{payment.amount | formatAmount}}
                                                        <span class="float-right" style="cursor:pointer;" @click="removeFromPaymentList(index)"><i class="nc-icon nc-simple-remove"></i></span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="col-md-3">
                                    <div class="card-body" style="background:#F1F6FF;height: 100%;">
                                        <div class="row" v-if="sale.customerId!=null">
                                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <label v-if="sale.salePayment.paymentType=='Cash'">{{ $t('AddSale.CashAccount') }}:</label>
                                                <label v-if="sale.salePayment.paymentType=='Bank'">{{ $t('AddSale.BankAccount') }}:</label>
                                                <label v-if="sale.salePayment.paymentType=='Advance'">{{ $t('AddSale.AdvanceAccount') }}:</label>

                                                <accountdropdown v-model="sale.bankCashAccountId" :disabled="sale.salePayment.paymentType=='Advance'" :formName="sale.salePayment.paymentType=='Cash'? 'CashPay' : sale.salePayment.paymentType=='Bank'? 'BankPay' :'AdvanceReceipt'" :advance="'true'" :key="accountRender"></accountdropdown>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" v-if="sale.salePayment.paymentType == 'OtherCurrency'">
                                                <label>{{ $t('AddSale.Amount') }}:</label>
                                                <div>
                                                    <input type="number" class="form-control" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'"
                                                           @focus="$event.target.select()" @input="OtherCurrencyCalculate()"
                                                           style="background:#ffffff;"
                                                           v-model="sale.otherCurrency.amount" />
                                                </div>
                                            </div>

                                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" v-if="sale.salePayment.paymentType == 'OtherCurrency'">
                                                <label> {{ $t('AddSale.Rate') }}:</label>
                                                <div>
                                                    <input type="number" class="form-control" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'"
                                                           @focus="$event.target.select()" @input="OtherCurrencyCalculate()"
                                                           style="background:#ffffff;"
                                                           v-model="sale.otherCurrency.rate" />
                                                </div>
                                            </div>

                                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" v-if="sale.salePayment.paymentType == 'OtherCurrency'">
                                                <label>{{ $t('AddSale.Total') }}:</label>
                                                <div>
                                                    <input type="number" class="form-control" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'"
                                                           @focus="$event.target.select()"
                                                           disabled
                                                           :value="(sale.otherCurrency.rate * sale.otherCurrency.amount) | roundAmount" />
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <label>{{ $t('AddSale.DueAmount') }}:</label>
                                                <input type="text" class="form-control" :value="sale.salePayment.dueAmount  | roundAmount" disabled />
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <label>{{ $t('AddSale.Received') }} :</label>
                                                <div>
                                                    <span>
                                                        <input type="number" class="form-control"
                                                               @focus="$event.target.select()"
                                                               style="background:#ffffff;"
                                                               @keyup="calculatBalance($event.target.value)"
                                                               v-model="sale.salePayment.received" />
                                                    </span>
                                                    <span style="position:absolute; right:20px; top:20px;" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? '' : 'add_btn'">
                                                        <button class="btn btn-primary btn-round btn-sm btn-icon" @click="addPayment(sale.salePayment.received, sale.salePayment.paymentType, sale.customerId==null? sale.salePayment.paymentName:sale.salePayment.paymentType)"
                                                                :disabled="!(sale.salePayment.paymentType=='Bank' && sale.salePayment.received > 0) && !(sale.salePayment.paymentType=='Cash' && sale.salePayment.received > 0) && !(sale.salePayment.paymentType=='Advance' && sale.salePayment.received > 0)">
                                                            <i class="nc-icon bord rounded-circle nc-simple-add"></i>
                                                        </button>
                                                    </span>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="col-md-3">
                                    <div class="card-body" style="background:#F1F6FF;height: 100%;">
                                        <div class="row" v-if="sale.saleOrderId!='' && sale.saleOrderId!=null && autoPaymentVoucher">
                                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <label>{{ $t('AddSale.AdvanceBalance') }} :</label>
                                                <div>
                                                    <input type="number" class="form-control" disabled @focus="$event.target.select()"
                                                           :value="soPaymentTotal  | roundAmount" />
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <label>{{ $t('AddSale.Balance') }} :</label>
                                                <div>
                                                    <input type="number" class="form-control" disabled @focus="$event.target.select()"
                                                           :value="sale.salePayment.balance  | roundAmount" />
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <label>{{ $t('AddSale.Change') }}  :</label>
                                                <div>
                                                    <input type="number" class="form-control" disabled @focus="$event.target.select()"
                                                           :value="sale.salePayment.change | roundAmount" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-3" v-bind:style="($i18n.locale == 'en' ||isLeftToRight()) ? '' : 'direction: rtl'">
                                                <h6>{{ $t('AddSale.SummarySI') }}: <span v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'float-right' : 'float-left'" style="color:#3178F6;">{{sale.registrationNo}}</span> </h6>
                                                <div>
                                                    <p>{{ $t('AddSale.InvoiceTotal') }}: {{currency}} {{summary.total | formatAmount}}</p>
                                                    <p>{{ $t('AddSale.Discount') }} : {{summary.discount | formatAmount}}</p>
                                                    <p>{{ $t('AddSale.TotalAfterDiscount') }}  : {{currency}} {{summary.withDisc | formatAmount}}</p>
                                                    <p>{{ $t('AddSale.VAT') }}   : {{currency}} {{parseFloat(summary.vat) | formatAmount}}</p>
                                                    <p v-if="summary.bundleAmount > 0">{{ $t('AddSale.BundleAmount') }}   : <span class="badge badge-info">{{ summary.bundleAmount | formatAmount }}</span></p>
                                                    <p>{{ $t('AddSale.TotalWithVat') }}   : {{currency}} {{summary.withVat | formatAmount}}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row ">
                            </div>

                            <div v-if="!loading" class="col-md-12 arabicLanguage">
                                <button class="btn btn-primary mr-2 float-left"
                                        v-on:click="onPayScreen=false"
                                        block v-b-toggle.accordion-1 variant="info">
                                    {{ $t('AddSale.EditInvoice') }}
                                </button>
                                <button class="btn btn-success mr-2"
                                        v-on:click="saveSale('Paid',false)"
                                        :disabled="!isPaymentValid">
                                    {{ $t('AddSale.Submit') }}
                                </button>

                                <button class="btn btn-success mr-2"
                                        v-if="isValid('CanPrintInvoices')"
                                        v-on:click="saveSale('Paid',true)"
                                        :disabled="!isPaymentValid">
                                    Submit as Print
                                </button>
                                <button class="btn btn-outline-danger mr-2"
                                        v-on:click="goToSale">
                                    {{ $t('AddSale.Cancel') }}
                                </button>
                            </div>
                            <div class="card-footer col-md-3" v-else>
                                <loading :name="loading" :active.sync="loading"
                                         :can-cancel="false"
                                         :is-full-page="true"></loading>
                            </div>
                        </b-card-body>
                    </b-collapse>
                </b-card>
            </div>
            <div class="col-lg-6 col-sm-6 ml-auto mr-auto" v-else>
                <div class="card p-3 text-center " v-if="bankDetail">
                    <h4 class="">{{ $t('AddSale.FirstStartInvoice') }}</h4>
                    <router-link :to="{path: '/WholeSaleDay', query: { token_name:'DayStart_token', fromDashboard:'true' } }"><a href="javascript:void(0)" class="btn btn-outline-danger ">{{ $t('AddSale.DayStart') }}</a></router-link>
                </div>
                <div class="card p-3 text-center " v-else>
                    <h4 class="">{{ $t('AddSale.FirstStartInvoice') }}</h4>
                    <router-link :to="{path: '/dayStart', query: { token_name:'DayStart_token', fromDashboard:'true' } }"><a href="javascript:void(0)" class="btn btn-outline-danger ">{{ $t('AddSale.DayStart') }}</a></router-link>
                </div>
            </div>
            <bulk-attachment :attachmentList="sale.attachmentList" :show="show" v-if="show" @close="attachmentSave" />

            <!--<saleInvoice :printDetails="printDetails" v-if="printDetails.length != 0" v-bind:key="printRender"></saleInvoice>-->
            <usc-report-print :printDetails="printDetails" :isTouchScreen="sale" :headerFooter="headerFooter" v-if="printDetails.length != 0 && printSize=='A4' && printTemplate=='Template4'" v-bind:key="printRender" />

            <cash-voucher-report :printDetail="printDetailsCashVoucher" v-bind:isTouchScreen="addSale" :headerFooter="headerFooter" v-if="printDetailsCashVoucher.length != 0" v-bind:key="printRender" />
            <readymade-garments :printDetail="printDetailsPos" v-bind:isTouchScreen="addSale" :headerFooter="headerFooter" v-if="printDetailsPos.length != 0 && printSize=='Thermal' && printTemplate=='Default'" v-bind:key="printRender" />
            <SalesThermalSaudiReports3 :printDetail="printDetailsPos" v-bind:isTouchScreen="addSale" :headerFooter="headerFooter" v-if="printDetailsPos.length != 0 && printSize=='Thermal' && printTemplate=='RetailSaTemplate1'" v-bind:key="printRender" />
            <SalesThermalSaudiReports4 :printDetail="printDetailsPos" v-bind:isTouchScreen="addSale" :headerFooter="headerFooter" v-if="printDetailsPos.length != 0 && printSize=='Thermal' && printTemplate=='RetailSaTemplate2'" v-bind:key="printRender" />
            <PaksitanClientInvoiceTemplate :printDetails="printDetails" :isTouchScreen="addSale" :headerFooter="headerFooter" v-if="printDetails.length != 0  && printTemplate=='Template9'" v-bind:key="printRender" />

            <saleInvoice :color="true" :printDetails="printDetails" v-bind:isTouchScreen="addSale" :headerFooter="headerFooter" v-if="printDetails.length != 0 && printTemplate=='Default'" v-bind:key="printRender" />
            <ObaagestSaleInvoice :color="true" :printDetails="printDetails" v-bind:isTouchScreen="addSale" :headerFooter="headerFooter" v-if="printDetails.length != 0 && printTemplate=='Template8'" v-bind:key="printRender" />
            <saleInvoice-template-one :printDetails="printDetails" :isTouchScreen="addSale" :headerFooter="headerFooter" v-if="printDetails.length != 0 && printTemplate=='Template1'" v-bind:key="printRender" />
            <saleinvoice-dotMatrixprint :printDetails="printDetails" :isTouchScreen="addSale" :headerFooter="headerFooter" v-if="printDetails.length != 0 && printTemplate=='Template2'" v-bind:key="printRender" />
        </div>
        <div v-else> <acessdenied></acessdenied></div>
    </div>




</template>
<script>
    /* END EXTERNAL SOURCE */
    /* BEGIN EXTERNAL SOURCE */

    import moment from "moment";
    import Loading from 'vue-loading-overlay';
    import "vue-loading-overlay/dist/vue-loading.css";
    import { required, requiredIf } from "vuelidate/lib/validators";
    import clickMixin from '@/Mixins/clickMixin'
    import Multiselect from "vue-multiselect";
    //import VueBarcode from 'vue-barcode';
    export default {
        name: "AddSale",
        mixins: [clickMixin],
        components: {
            Multiselect,
            Loading
        },
        data: function () {
            return {
                poNumber: '',
                printSize: '',
                printTemplate: '',
                onPayScreen: false,
                show: false,
                isFifo: false,
                openBatch: 0,
                saleOrderPerm: false,
                bankDetail: false,
                autoPaymentVoucher: false,
                soPaymentTotal: 0,
                customerRender: 0,
                logisticRender: 0,
                saleOrder: false,
                isRaw: '',
                isMultiUnit: '',
                isForMedical: '',
                isArea: '',
                removeCheck: false,
                options: [],
                value: "",
                bankList: [],
                currencyList: [],
                autoNumber: '',
                autoNumberCredit: '',
                toggleCash: false,
                toggleCredit: true,
                currency: '',
                togglePayCash: 'Cash',
                language: 'Nothing',
                paymentMethod: '',

                toggleBank: 'Bank',
                toggleAdvance: 'Advance',
                addSale: 'addSale',
                toggleOtherCurrency: 'OtherCurrency',

                rendered: 0,
                sale: {
                    id: "00000000-0000-0000-0000-000000000000",
                    dispatchNote: [],
                    barCode: "",
                    saleOrderId: "",
                    quotationId: "",
                    date: "",
                    poDate: "",
                    poNumber: "",
                    doctorName: "",
                    hospitalName: "",
                    counterId: '',
                    logisticId: '',
                    dayStart: false,
                    isWarranty: false,
                    registrationNo: "",
                    customerId: null,
                    dueDate: "",
                    wareHouseId: "",
                    saleItems: [],
                    attachmentList: [],
                    isCredit: false,
                    cashCustomer: "",
                    mobile: "",
                    email: "",
                    cashCustomerId: "",
                    code: "",
                    invoiceType: "",
                    employeeId: "",
                    areaId: "",
                    customerAddressWalkIn: "",
                    change: 0,
                    soInventoryReserve: '',
                    isSerial: false,
                    autoPaymentVoucher: '',
                    salePayment: {
                        dueAmount: 0,
                        received: 0,
                        balance: 0,
                        change: 0,
                        paymentTypes: [],
                        paymentType: 'Cash',
                        paymentOptionId: null,
                        paymentName: 'Cash',
                    },
                    otherCurrency: {
                        currencyId: null,
                        rate: 0,
                        amount: 0
                    },

                    creditPays: [],
                    bankCashAccountId: '',
                    userName: '',
                    isCashInvoicesForCustomer: false,
                    partiallyQuotation: false,
                    partiallySaleOrder: false,
                    colorVariants: false,
                    taxMethod: '',
                    taxRateId: '',
                    discount:0
                },
                printId: '00000000-0000-0000-0000-000000000000',
                printDetailsPos: [],
                printDetailsCashVoucher: [],
                printDetails: [],
                printRender: 0,
                loading: false,
                summary: Object,
                search: '',
                UserID: '',
                employeeId: '',
                customerAdvanceAccountId: '',
                isDayAlreadyStart: false,
                IsProduction: false,
                headerFooter: {
                    returnDays: '',
                    footerEn: '',
                    footerAr: '',
                    printSizeA4: '',
                    company: ''
                },
                accountRender: 0,
                overWrite: false,
                BusinessLogo: '',
                BusinessNameArabic: '',
                BusinessNameEnglish: '',
                BusinessTypeArabic: '',
                BusinessTypeEnglish: '',
                CompanyNameArabic: '',
                CompanyNameEnglish: '',
                priceType: null,
                priceoptions: [{ id: 1, name: 'Retail Price' }, { id: 2, name: 'Wholesale Price' }],
                wholesalePriceActivation: false,
                saleDefaultVat: '',
                creditPayment:0
            };
        },
        validations: {
            sale: {
                date: { required },
                registrationNo: { required },
                customerId: {
                    required: requiredIf((x) => {

                        if (x.isCredit) {
                            if (x.customerId == '00000000-0000-0000-0000-000000000000' || x.customerId == null)
                                return true;
                        }
                        else if (x.isCashInvoicesForCustomer)
                            if (x.customerId == '00000000-0000-0000-0000-000000000000' || x.customerId == null)
                                return true;
                        return false;
                    })
                },
                cashCustomer: {
                    required: requiredIf((x) => {

                        if (!x.isCredit)
                            if (x.customerId == '00000000-0000-0000-0000-000000000000' || x.customerId == null)
                                return true;
                        return false;
                    })
                },


                dueDate: {},
                wareHouseId: {},
                saleItems: {
                    required
                },
                mobile: {},
                code: {},
            }
        },
        computed: {
            isColorVariantsValid: function () {
                debugger;
                if (this.sale.saleItems.length > 0 && this.sale.colorVariants) {
                    if (this.sale.saleItems.filter(x => x.colorId == '' || x.colorId == null || x.colorId == undefined).length > 0) {
                        return false;
                    }
                    return true;
                }

                return true;
            },

            isPaymentValid: function () {
                var paymentTypesAmount;
                if (this.sale.salePayment.paymentTypes.length > 0) {
                    paymentTypesAmount = this.sale.salePayment.paymentTypes.reduce((total, payment) =>
                        total + payment.amount, 0);
                } else {
                    paymentTypesAmount = 0;
                }

                if (this.sale.salePayment.paymentType == "Bank" && this.sale.customerId != null && this.sale.customerId != '') {

                    if (this.sale.bankCashAccountId == "00000000-0000-0000-0000-000000000000" ||
                        this.sale.bankCashAccountId == null) {
                        return false;
                    }
                }

                if (this.sale.salePayment.paymentType == "Bank" && (this.sale.customerId == null || this.sale.customerId == '')) {

                    if (this.sale.salePayment.paymentOptionId == "00000000-0000-0000-0000-000000000000" ||
                        this.sale.salePayment.paymentOptionId == null) {
                        return false;
                    }
                }

                if (this.sale.salePayment.paymentType == "OtherCurrency") {
                    if (this.sale.otherCurrency.currencyId == "00000000-0000-0000-0000-000000000000" ||
                        this.sale.otherCurrency.currencyId == null) {
                        return false;
                    }
                }


                if ((parseFloat(this.sale.salePayment.received) <= parseFloat(this.sale.salePayment.dueAmount))) {
                    if (((parseFloat(this.sale.salePayment.received) + paymentTypesAmount)) >= this.sale.salePayment.dueAmount) {
                        return true
                    }
                } else {
                    if (((parseFloat(this.sale.salePayment.received) + paymentTypesAmount)) >= this.sale.salePayment.dueAmount) {
                        return true
                    }
                }
                return false;
            },

        },
        methods: {
            getCreditAmount: function (data) {
                this.sale.creditPays = data;
                this.creditPayment = 0;
                var root = this
                if (this.sale.creditPays !== null && this.sale.creditPays.length > 0) {
                    this.sale.creditPays.forEach(function (item) {

                        root.creditPayment = root.creditPayment + parseFloat(item.amount);

                    })
                }
            },
            Attachment: function () {
                this.show = true;
            },

            attachmentSave: function (attachment) {

                this.sale.attachmentList = attachment;
                this.show = false;
            },

            getAddress: function () {
                this.sale.customerAddressWalkIn = this.$refs.CustomerDropdown.GetCustomerAddress().address;
                this.sale.mobile = this.$refs.CustomerDropdown.GetCustomerAddress().mobile;
            },
            cashCustomerSearch: function (value) {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                if (value != '') {
                    this.$https.get('/Sale/SearchCashCustomer?search=' + value, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                        if (response.data != null) {
                            root.sale.cashCustomer = response.data.name;
                            root.sale.mobile = response.data.mobile;
                            root.sale.email = response.data.email;
                            root.sale.cashCustomerId = response.data.customerId;
                            root.sale.customerAddressWalkIn = response.data.address;
                        }
                    })
                }
                else {
                    root.sale.cashCustomer = 'Walk-In';
                    root.sale.mobile = '';
                    root.sale.cashCustomerId = '';
                    root.sale.email = '';
                }

            },
            isDayStart: function () {

                var root = this;

                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.loading = true;
                root.$https.get('/Product/IsDayStart?userId=' + this.UserID + '&employeeId=' + this.employeeId, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data.isDayStart == true) {

                            root.isDayAlreadyStart = true;
                            localStorage.setItem('token', response.data.token);

                            root.getBank();
                            if ((root.$i18n.locale == 'en' || root.isLeftToRight())) {
                                root.sale.cashCustomer = "Walk-In";
                            }
                            else {
                                root.sale.cashCustomer = "ادخل";
                            }
                            root.getCurrency();
                            root.isArea = localStorage.getItem('IsArea');
                            root.currency = localStorage.getItem('currency');
                            root.isMultiUnit = localStorage.getItem('IsMultiUnit');
                            root.isRaw = localStorage.getItem('IsProduction');
                            if (root.$route.query.data == undefined) {

                                root.sale.date = moment().format("LLL");
                                root.sale.dueDate = moment().format("LLL");
                            }
                            root.AutoIncrementCode();
                            if (root.$route.query.data != undefined) {
                                root.warehouse = root.$route.query.data;
                            }

                            if (root.$route.query.mobiledata != undefined) {
                                root.sale.date = root.$route.query.mobiledata.orderDate;
                            }
                        } else {
                            root.isDayAlreadyStart = false;
                        }
                        root.loading = false;

                    });
            },
            languageChange: function (lan) {
                if (this.language == lan) {
                    if (this.sale.id == '00000000-0000-0000-0000-000000000000') {

                        var getLocale = this.$i18n.locale;
                        this.language = getLocale;

                        this.$router.go('/addSale');
                    }
                    else {
                        this.$swal({
                            title: this.$t('AddSale.Error'),
                            text: this.$t('AddSale.ChangeLanguageError'),
                            confirmButtonClass: "btn btn-danger",
                            icon: 'error',
                            timer: 4000,
                            timerProgressBar: true,
                        });
                    }
                }
            },

            GetSaleOrderDetail: function (id) {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                if (id != undefined) {

                    root.$https.get('/Purchase/SaleOrderDetail?Id=' + id + '&isFifo=' + this.isFifo + '&openBatch=' + this.openBatch, { headers: { "Authorization": `Bearer ${token}` } })
                        .then(function (response) {
                            if (response.data != null) {
                                root.paymentMethod = response.data.paymentMethod;
                                root.sale.isCredit = response.data.paymentMethod == "Credit" ? true : false;
                                root.sale.customerId = response.data.customerId;
                                root.sale.logisticId = response.data.logisticId;
                                root.sale.mobile = response.data.mobile;
                                root.sale.customerAddressWalkIn = response.data.customerAddress;
                                root.sale.taxMethod = response.data.taxMethod;
                                root.sale.taxRateId = response.data.taxRateId;

                                root.customerAdvanceAccountId = response.data.advanceAccountId;
                                root.$refs.childComponentRef.EmtySaleProductList();
                                response.data.saleOrderItems.forEach(function (so) {

                                    if (so.quantityOut > 0) {
                                        if (localStorage.getItem('IsMultiUnit') == 'true') {
                                            so.highQty = parseInt(parseInt(so.quantityOut) / parseInt(so.product.unitPerPack));
                                            so.quantityOut = parseInt(parseInt(so.quantityOut) % parseInt(so.product.unitPerPack));
                                        }
                                        root.$refs.childComponentRef.addProduct(so.productId, so.product, so.quantityOut, so.unitPrice, true, so.quantityOut, so);
                                    }
                                });
                                root.GetSaleOrderUsedPaymentDetail(response.data.id);

                                root.soPaymentTotal = response.data.paymentVoucher.reduce((total, item) => total + item.amount, 0);
                                root.customerRender++;
                                root.logisticRender++;
                            }
                        },
                            function (error) {
                                root.loading = false;
                                console.log(error);
                            });
                }
            },
            GetSaleOrderUsedPaymentDetail: function (id) {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get('/Purchase/SaleInvoicePaymentList?Id=' + id, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data != null) {

                            var remaining = root.soPaymentTotal - response.data;
                            if (remaining > 0) {
                                root.soPaymentTotal = remaining;
                            }
                            else {
                                root.soPaymentTotal = 0;
                            }
                            console.log(root.soPaymentTotal);
                        }
                    },
                        function (error) {
                            root.loading = false;
                            console.log(error);
                        });

            },
            GetDispatchNoteDetail: function (id, index) {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                if (id != undefined) {
                    root.$https.get('/Sale/DispatchNoteDetail?Id=' + id[index - 1].id, { headers: { "Authorization": `Bearer ${token}` } })
                        .then(function (response) {
                            if (response.data != null) {
                                response.data.dispatchNoteItems.forEach(function (dn) {
                                    root.$refs.childComponentRef.addProduct(dn.productId, dn.product, dn.quantity);
                                });
                            }
                        },
                            function (error) {
                                root.loading = false;
                                console.log(error);
                            });
                }
            },
            getBank: function () {
                var root = this;
                var token = '';

                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                this.$https.get('/Product/PaymentOptionsList?isActive=true', { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {
                        root.bankList = response.data.paymentOptions;
                    }
                })
            },
            selectBank: function (id, name) {
                this.otherCurrencyId = null;
                this.bankId = id;
                this.isActive = true;
                this.sale.salePayment.paymentOptionId = id;
                this.sale.salePayment.paymentName = name;
            },
            getCurrency: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                this.$https.get('/Product/CurrencyList', { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {
                        root.currencyList = response.data.currencies;
                        root.currencyList.splice(0, 1);
                    }
                })
            },
            selectCurrency: function (id, name) {
                this.bankId = null;
                this.otherCurrencyId = id;
                this.isActive = true;
                this.sale.otherCurrency.currencyId = id;
                this.sale.salePayment.paymentName = name;
            },
            isCredit: function (credit) {

                console.log(credit);
                this.sale.isCredit = credit;
                if (!this.sale.isCredit) {
                    this.sale.customerId = null;
                    this.sale.customerAddressWalkIn = null;
                    this.sale.cashCustomer = "Walk-In";
                    this.paymentMethod = 'Cash';
                }
                else {
                    this.paymentMethod = 'Credit';
                }
            },
            isPayment: function (credit) {

                if (credit == 'Advance') {
                    this.sale.bankCashAccountId = this.customerAdvanceAccountId;
                    this.accountRender++;
                }
                this.sale.salePayment.paymentType = credit;
                this.accountRender++;
            },
            emptyCashCustomer: function (customerId, advanceAccountId) {

                this.sale.customerId = customerId;
                this.customerAdvanceAccountId = advanceAccountId;

                if (this.sale.customerId != '00000000-0000-0000-0000-000000000000' && this.sale.customerId != null) {
                    if (this.sale.isCredit) {
                        this.paymentMethod = 'Credit';
                    }
                    this.sale.cashCustomer = "";
                    this.sale.mobile = "";
                    this.sale.cashCustomerId = "";
                    this.sale.email = "";
                    this.search = "";
                }
                else {
                    this.paymentMethod = 'Cash';
                    this.sale.cashCustomer = "Walk-In";
                }
                if (this.isRaw == 'true') {
                    var root = this;
                    var token = "";
                    if (this.$session.exists()) {
                        token = localStorage.getItem("token");
                    }
                    root.options = [];
                    this.$https
                        .get('/Sale/DispatchNoteList?isDropdown=' + true + '&customerId=' + customerId, {
                            headers: { Authorization: `Bearer ${token}` },
                        })
                        .then(function (response) {

                            if (response.data != null) {
                                response.data.results.forEach(function (dn) {
                                    root.options.push({
                                        id: dn.id,
                                        name: dn.registrationNumber,
                                    });
                                });
                            }
                        })
                        .then(function () {
                            root.value = root.options.find(function (x) {
                                return x.id == root.values;
                            });
                        });
                }

            },

            setCustomer: function (value) {
                console.log(value);
            },
            OnEditInvoice: function () {


                this.updateSummary(this.summary);
                this.sale.salePayment.dueAmount = (this.sale.salePayment.dueAmount) <= 0 ? '0' : (this.sale.salePayment.dueAmount);
                var total = 0;
                if (this.sale.salePayment.paymentTypes != '' && this.sale.salePayment.paymentTypes != undefined) {
                    this.sale.salePayment.paymentTypes.forEach(x => {

                        total += x.amount;
                    });
                    total = total + parseFloat(this.sale.salePayment.received);
                }
                if (total != 0) {
                    if (this.sale.salePayment.balance <= total) {
                        this.sale.salePayment.balance = 0;
                        this.sale.salePayment.change = total - this.sale.salePayment.dueAmount;
                    }
                }

                this.onPayScreen = true;
            },
            calculatBalance: function (received) {

                if (received == '') {
                    received = 0;
                }
                var paymentTypesAmount;
                if (this.sale.salePayment.paymentTypes.length > 0) {
                    paymentTypesAmount = this.sale.salePayment.paymentTypes.reduce((total, payment) =>
                        total + payment.amount, 0);
                } else {
                    paymentTypesAmount = 0;
                }

                this.sale.salePayment.balance = (parseFloat(received) + paymentTypesAmount) - this.sale.salePayment.dueAmount < 0 ? (parseFloat(received) + paymentTypesAmount) - this.sale.salePayment.dueAmount : 0;
                this.sale.salePayment.change = (parseFloat(received) + paymentTypesAmount) - this.sale.salePayment.dueAmount > 0 ? (parseFloat(received) + paymentTypesAmount) - this.sale.salePayment.dueAmount : 0;
                this.sale.change = this.sale.salePayment.change;
            },
            OtherCurrencyCalculate: function () {
                this.sale.salePayment.received = parseFloat(this.sale.otherCurrency.amount == '' ? 0 : this.sale.otherCurrency.amount).toFixed(3).slice(0, -1) * parseFloat(this.sale.otherCurrency.rate == '' ? 0 : this.sale.otherCurrency.rate).toFixed(3).slice(0, -1);
            },
            addPayment: function (amount, paymentType, name) {
                var root = this;

                this.sale.salePayment.received = 0;
                if (paymentType == 'Cash') {
                    var payment = this.sale.salePayment.paymentTypes.find((x) => x.paymentType == paymentType)
                    if (payment != undefined) {
                        payment.amount += parseFloat(amount);
                        payment.name = name;
                    }
                    else {
                        this.sale.salePayment.paymentTypes.push({ paymentType: paymentType, amount: parseFloat(amount), name: name, rate: 0, otherAmount: 0, bankCashAccountId: root.sale.bankCashAccountId });
                    }
                }
                else if (paymentType == 'Bank') {

                    this.sale.salePayment.paymentTypes.push({ paymentType: paymentType, amount: parseFloat(amount), name: name, rate: 0, otherAmount: 0, bankCashAccountId: root.sale.bankCashAccountId });
                }
                else if (paymentType == 'CashVoucher') {
                    this.sale.salePayment.paymentTypes.push({ paymentType: paymentType, amount: parseFloat(amount), name: name, rate: 0, otherAmount: 0, bankCashAccountId: root.sale.bankCashAccountId });
                }
                else {
                    this.sale.salePayment.paymentTypes.push({ paymentType: paymentType, amount: parseFloat(amount), name: name, rate: root.sale.otherCurrency.rate, otherAmount: root.sale.otherCurrency.amount, bankCashAccountId: root.sale.bankCashAccountId });
                }
                //var payment = this.sale.salePayment.paymentTypes.find((x) => x.paymentType == paymentType)
                //if (payment != undefined) {
                //    payment.amount += parseFloat(amount);
                //} else {
                //    this.sale.salePayment.paymentTypes.push({ paymentType: paymentType, amount: parseFloat(amount) });
                //}

                this.calculatBalance(0);
                this.sale.otherCurrency.amount = 0;
                this.sale.otherCurrency.rate = 0;
            },

            removeFromPaymentList: function (paymentType) {
                this.sale.salePayment.paymentTypes.splice(paymentType, 1);
                //this.sale.salePayment.paymentTypes = this.sale.salePayment.paymentTypes.filter((x) =>
                //    x.paymentType != paymentType);

                this.calculatBalance(0);
            },

            updateSummary: function (summary) {
                this.summary = summary;

                this.sale.salePayment.dueAmount = parseFloat(this.summary.withVat)
            },
            AutoIncrementCode: function () {

                var root = this;
                var token = "";
                if (root.$session.exists()) {
                    token = localStorage.getItem("token");
                }

                root.$https.get("/Sale/SaleAutoGenerateNo", { headers: { Authorization: `Bearer ${token}` }, })
                    .then(function (response) {
                        if (response.data != null) {
                            if (root.sale.id == '00000000-0000-0000-0000-000000000000') {
                                root.sale.registrationNo = response.data.paid;
                                root.autoNumber = response.data.hold;
                                root.autoNumberCredit = response.data.credit;
                            }
                            else {
                                root.autoNumber = response.data.paid;
                                root.autoNumberCredit = response.data.credit;
                            }
                        }
                    })
                    .catch(error => {
                        console.log(error)
                        root.$swal.fire(
                            {
                                icon: 'error',
                                title: 'Cannot Generate Auto Inoice Number!',
                                text: error.response.data,
                                showConfirmButton: false,
                                timer: 5000,
                                timerProgressBar: true,
                            });
                    });
            },
            SaveSaleItems: function (saleItems) {
                this.sale.saleItems = saleItems;
            },
            PrintInvoice: function (value) {

                var id = value;
                var root = this;
                this.isTouchScreen = true;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.printDetails = [];
                root.printDetailsCashVoucher = [];
                root.$https.get("/Sale/SaleDetail?id=" + id, { headers: { Authorization: `Bearer ${token}` }, })
                    .then(function (response) {
                        if (response.data != null) {

                            root.printDetailsPos = response.data;

                            if (localStorage.getItem('IsMultiUnit') == 'true') {

                                root.printDetails.saleItems.forEach(function (x) {

                                    x.highQty = parseInt(parseInt(x.quantity) / parseInt(x.product.unitPerPack));
                                    x.newQuantity = parseInt(parseInt(x.quantity) % parseInt(x.product.unitPerPack));
                                    x.unitPerPack = x.product.unitPerPack;
                                });
                            }
                            root.printRender++;
                            root.loading = false
                        }
                    })
                    .catch(error => {
                        console.log(error)
                        root.loading = false
                        root.$router.go({
                            path: '/addSale'
                        });
                    });
            },
            PrintInvoiceA4: function (value) {

                var id = value;
                var root = this;
                var token = '';

                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.printDetailsPos = [];
                root.printDetailsCashVoucher = [];
                root.$https.get("/Sale/SaleDetail?id=" + id, {
                    headers: { Authorization: `Bearer ${token}` },
                })
                    .then(function (response) {
                        if (response.data != null) {
                            if (localStorage.getItem('IsMultiUnit') == 'true') {

                                response.data.saleItems.forEach(function (x) {

                                    x.highQty = parseInt(parseInt(x.quantity) / parseInt(x.product.unitPerPack));
                                    x.newQuantity = parseInt(parseInt(x.quantity) % parseInt(x.product.unitPerPack));
                                    x.unitPerPack = x.product.unitPerPack;
                                });
                            }
                            root.printDetails = response.data;
                            root.printRender++;
                            root.loading = false
                        }
                    })
                    .catch(error => {
                        console.log(error)
                        root.loading = false
                        root.$router.go({
                            path: '/addSale'
                        });
                    });
            },
            GetHeaderDetail: function () {
                var root = this;

                root.$https.get("/Company/GetCompanyDetail?id=" + localStorage.getItem('CompanyID'), { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }, })
                    .then(function (response) {
                        if (response.data != null) {
                            root.headerFooter.company = response.data;
                            if (root.overWrite) {

                                root.headerFooter.company.nameArabic = root.BusinessNameArabic;
                                root.headerFooter.company.nameEnglish = root.BusinessNameEnglish;
                                root.headerFooter.company.categoryArabic = root.BusinessTypeArabic;
                                root.headerFooter.company.categoryEnglish = root.BusinessTypeEnglish;

                                root.headerFooter.company.companyNameArabic = root.CompanyNameArabic;
                                root.headerFooter.company.companyNameEnglish = root.CompanyNameEnglish;


                                root.headerFooter.company.logoPath = root.BusinessLogo;
                            }
                            root.GetInvoicePrintSetting();
                            root.getBase64Image(root.headerFooter.company.logoPath);
                        }
                    });
            },
            GetInvoicePrintSetting: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get('/Sale/printSettingDetail', { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data != null && response.data != '') {

                            root.headerFooter.footerEn = response.data.termsInEng;
                            root.headerFooter.footerAr = response.data.termsInAr;
                            root.headerFooter.isHeaderFooter = response.data.isHeaderFooter;
                            root.headerFooter.englishName = response.data.englishName;
                            root.headerFooter.arabicName = response.data.arabicName;
                            root.headerFooter.customerAddress = response.data.customerAddress;
                            root.headerFooter.customerVat = response.data.customerVat;
                            root.headerFooter.customerNumber = response.data.customerNumber;
                            root.headerFooter.cargoName = response.data.cargoName;
                            root.headerFooter.customerTelephone = response.data.customerTelephone;
                            root.headerFooter.itemPieceSize = response.data.itemPieceSize;
                            root.headerFooter.styleNo = response.data.styleNo;
                            root.headerFooter.blindPrint = response.data.blindPrint;
                            root.headerFooter.showBankAccount = response.data.showBankAccount;
                            root.headerFooter.bankAccount1 = response.data.bankAccount1;
                            root.headerFooter.bankAccount2 = response.data.bankAccount2;
                            root.headerFooter.bankIcon1 = response.data.bankIcon1;
                            root.headerFooter.bankIcon2 = response.data.bankIcon2;
                            root.headerFooter.customerNameEn = response.data.customerNameEn;
                            root.headerFooter.customerNameAr = response.data.customerNameAr;
                            root.headerFooter.exchangeDays = response.data.exchangeDays;
                            root.headerFooter.printOptions = response.data.printOptions;
                            root.headerFooter.invoicePrint = response.data.invoicePrint;
                            root.headerFooter.welcomeLineEn = response.data.welcomeLineEn;
                            root.headerFooter.welcomeLineAr = response.data.welcomeLineAr;
                            root.headerFooter.closingLineEn = response.data.closingLineEn;
                            root.headerFooter.closingLineAr = response.data.closingLineAr;
                            root.headerFooter.contactNo = response.data.contactNo;
                            root.headerFooter.managementNo = response.data.managementNo;

                        }
                    },
                        function (error) {
                            root.loading = false;
                            console.log(error);
                        });
            },
            getBase64Image: function (path) {
                var root = this;
                var token = '';
                if (root.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                this.headerFooter.company.logoPath = 'data:image/png;base64,' + 'iVBORw0KGgoAAAANSUhEUgAAATYAAACjCAMAAAA3vsLfAAAAhFBMVEX///8AcuEAZ98Ab+AAa+AAbeAAad9Tk+cAbuC+1fUFeOLS4/no8/0AZd8AaODv9v1to+vk7/z1+v7d6vqBru3F2vemxfKHsu5Zl+iYvfDU5PnM3/g9iea20PWNte5Rk+gwhOVIjuepx/NjnOl2p+wlfuS30fUAX96cvvAde+M1huWoxfIDNGHbAAAHKElEQVR4nO2d65aiOhBGJQlpVAKId6VVtJ3ROe//fgfvqSQocS3EjrV/NsEJ38qlqlKVabUQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEGQ30E6nG6ybcfrbPNkN2+6N68kDWVimzdHOYlYEFDP8yj1GWGT79q6+W7kQoZWfi/8IfwgmEzA/UVaY1/fiCX49k7V1wbC90wwMq2zt2/D1zOyDSkzinaAb/v19vgteEa2hSgV7TBVxQcscU/IlpB7qhUI9yeqvWxJ9EC1QrdR7f1uGGvZpndn6EW3Yf09bxRb2WZVVCsWOMcNEVvZtqqxZsafvKDvDWIp245XUq2Ypm77WpayaWONRYIxwTXjl2av6H1j2Mm2VgYb88bzwo8Nhz9MFU50X9L/hrCTbQVHmxhcn8QbxS7xk3o73ixWsvXgNgrdgYViBbM6u900VrLBORrt4NMf6KgSlzcFK9k2gdRWX/SV0eayi2Ul215uTLQ1/xsMxmBTV5/fACvZ5KWNGtoC2eiqlg6/BzayxbJs/o/eIAc/Vj1U/PuwkQ1spGynNxgA443X1OV3wEa2viwbNwQjFwxl0wGjja/1BlA2lw23p9c2k33xAz2smrr8DljtpLL/ZLIvgO8VuOzMW8kGZNE3yhi4V047pVaygUnI/6iPp3BHcPlAwUo24AZo9m4Ko0rC5fNSK9nAnuAxZRZmAZDN5R3BMt4G3QAykJ9NYACEjWvsdeMosg3bJZxO8Nowpsaz60Scb5X8BtFr7JteAJTN42X8PeVwdWBzKrLdcDZrL1ZCOWVwOv6hyVYKP8n2Rz0mpYyTiDPtV9webLaytfLgcdtDc6dXNnvZwvIULQm6bfarasdWtla7SjYDc3uKPiFba/dYN8eP5FvPyNYaPdCNEtfzjZ6SrTWM7u0LzHPZqzrzjGytOFfNtNtQEy4HPq48JVvh1Hci04tUrJxf1o48KVurtV4JxcgNmMjbjXzE61lWlC3SC2Rm41UUMRYU+IWvwLKp62bHjaUgMtERyRdlB/wCY1ZpPByNk8lkkizWXcfTTiHxrKB/otfrnUuvIGlB0/1EnKQ3/16P1t/DiutUf3hsPv+cZU2nu8gOYaADEWHL0QMt5uMVuTbn+XT2ml6+F+HCIwwksBUGRbmbFI6L5uAAkJHO7tPWwDiJDCEhKnKzpxQmxNScs/FHCTfVU+TPNiwxZBaVN/cY/YD6vjNxdqf8jGinAnebe8LtU4QbM/9upJsvYfN+cD8wzrY2Jfe/lpnRK5d1+LJq7gXeB+hW4XQgWsjNH3uxgetHCa1qNXtiZtXcY86vb4MqNXvByqq5WiDjHn218D1gJGJcMeLo37MM/WpVuMUbbttvE7grUpKNZnEaz8e+L/1xewk/fmmbKPUZ8/WJyxZ3/9lfjjJ62PYa004nZ+OMRvvrjNNKvhnPB9Ppzz/dxWAuD7cBzO0Gpdrj4/yNOtIylUDngPKLExqO1UMZp5MpgQx+Dh8mzOMeyKOHY8pfSfZZ31OSkVYv6H5DdOGGoD72oGitYXRHmFiZpSKstetNApKUIy2HWY1+jGFOs+ILdOHCZyqTcQRQIHrNQO13z8xmXYkZzEHV6zngyucP1OfOIJv8t8/cwNOsM6IDV0KubZXQBqS5+twZ5EnHr0fDiTGYRv/BetKl/nMgRZXuX/klrwQkzJPrSlYi2xLWXBns2QQYw86WqoWyDtF15zPLFmxCuwo/ZwsjgQ7kgWz+IHxUTzr9DNlSINs1OGSWje3AJOX/6b8HDRT/lZ/yUkDp2XX4mGWLhmBLYAb7Al544W6sUq50vBUylsjWAxd9mJwn0D5w9y4ysPVdJ5VZNk9JhiPamf0c+F4OF12N5Fgtv5j9RtkOgwcs+fqNFrCQjbubIgjDbZe9dPP3dOczkWU4GBzQ81evGlvDuIBwOOAG7frO6UvjS5ZbJj09mnVwAHIQ45hDT97kRTgDtLRoRxYizXxVBWhhUCZl1ihjzRBPcYgYpiVQPr1MrXQHzupPJRqhog2ZnILoaVvLb6h8PfmvRLl0zeP+ZtQeDkdJYLznKVGaB1GwWi5XvnZSHxl8L4eItbOTgPGIc+WE6nL/sN7cowXaH50/lx89uiH8wO0aXXUJK0E4n1mZl6WqSbBb/PurSkEpcfqU9EjqPczqAIWO28f1y9xdv+pGaFiboGpgeU/3j4anmhDnKOH+7sQTyqaYZvfTZz6jxu/ApjwjJmB6tvigtC7ykOzr8nG8wndgHnBU5KbMyPm2JKWyaP9RhR3pmGv/AZNHyb7MRVp3iL41+GTlbtijhHS3F1I5R+BzsrwnQvuLcKk9ZRFPnL5+vZT+buKJw9myECwbtB9FftL2IGPn9nS5cP9igTukvUOJZPVY2bF96HBsDUEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQmf8BckJbXFsgizoAAAAASUVORK5CYII=';
                if (path != null && path != '' && path != undefined) {
                    root.$https.get('/Contact/GetBaseImage?filePath=' + path, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {

                        if (response.data != null) {
                            root.filePath = response.data;
                            root.headerFooter.company.logoPath = 'data:image/png;base64,' + root.filePath;
                        }

                    });
                }

            },





            saveSale: function (invoiceType, print) {


                this.loading = true;
                var root = this;
                localStorage.setItem('active', invoiceType);
                root.sale.invoiceType = invoiceType;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                if (this.sale.salePayment.received != 0) {
                    this.addPayment(this.sale.salePayment.received, this.sale.salePayment.paymentType, this.sale.customerId == null ? this.sale.salePayment.paymentName : this.sale.salePayment.paymentType);
                }

                this.sale.isSerial = localStorage.getItem('IsSerial') == 'true' ? true : false;
                this.sale.isFifo = this.isFifo;
                this.sale.soInventoryReserve = localStorage.getItem('SoInventoryReserve');
                this.sale.autoPaymentVoucher = localStorage.getItem('AutoPaymentVoucher');
                this.sale.userName = localStorage.getItem('LoginUserName');


                this.sale.partiallyQuotation = localStorage.getItem('partiallyQuotation') == 'true' ? true : false;
                this.sale.partiallySaleOrder = localStorage.getItem('partiallySaleOrder') == 'true' ? true : false;
                this.sale.colorVariants = localStorage.getItem('ColorVariants') == 'true' ? true : false,

                    this.sale.saleItems.forEach(function (x) {
                        x.quantity = x.totalPiece;
                    });
                this.$https
                    .post('/Sale/SaveSaleInformation', root.sale, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(response => {


                        if (response.data.message.id != '00000000-0000-0000-0000-000000000000' && response.data.action == "Add") {

                            if (print) {
                                if (root.$route.query.isDuplicate == 'true') {
                                    root.addSale = 'sale';
                                }
                                if (root.headerFooter.printSizeA4 == 'Thermal') {
                                    root.PrintInvoice(response.data.message.id);
                                }

                                else {
                                    root.PrintInvoiceA4(response.data.message.id);
                                }
                            }
                            else {
                                root.loading = false
                                root.$swal({
                                    title: root.$t('AddSale.SavedSuccessfully'),
                                    text: root.$t('AddSale.Saved'),
                                    type: 'success',
                                    confirmButtonClass: "btn btn-success",
                                    buttonStyling: false,
                                    icon: 'success',
                                    timer: 1500,
                                    timerProgressBar: true,

                                }).then(function (ok) {
                                    if (ok != null) {
                                        if (root.sale.id == '00000000-0000-0000-0000-000000000000' && !root.sale.isDuplicate) {
                                            root.$router.go({
                                                path: '/addSale'
                                            });
                                        }
                                        else {
                                            root.$router.push({
                                                path: '/sale',
                                                query: {
                                                    data: 'AddSales'
                                                }
                                            });
                                        }

                                    }
                                });
                            }

                        }
                        else if (response.data.message.id != '00000000-0000-0000-0000-000000000000' && response.data.action == "Update") {
                            if (print) {
                                if (root.$route.query.data.isDuplicate == 'true') {
                                    root.addSale = 'duplicate';
                                }
                                else {
                                    root.addSale = 'sale';
                                }

                                if (root.headerFooter.printSizeA4 == 'Thermal') {
                                    root.PrintInvoice(response.data.message.id);
                                }

                                else {
                                    root.PrintInvoiceA4(response.data.message.id);
                                }
                            }
                            else {
                                root.loading = false
                                root.$swal({
                                    title: root.$t('AddSale.UpdateSuccessfully'),
                                    text: root.$t('AddSale.Updated'),
                                    type: 'success',
                                    confirmButtonClass: "btn btn-success",
                                    buttonStyling: false,
                                    icon: 'success',
                                    timer: 1500,
                                    timerProgressBar: true,

                                }).then(function (ok) {
                                    if (ok != null) {
                                        if (root.sale.invoiceType == 'Hold') {
                                            root.$router.push({
                                                path: '/sale',
                                                query: {
                                                    data: 'AddSales'
                                                }
                                            });
                                        }
                                        else {
                                            root.$router.push({
                                                path: '/sale',
                                                query: {
                                                    data: 'AddSales'
                                                }
                                            });
                                        }
                                    }
                                });
                            }

                        }
                        else {
                            root.loading = false
                            if (localStorage.getItem('IsMultiUnit') == 'true') {
                                root.sale.saleItems.forEach(function (x) {

                                    x.highQty = parseInt(parseInt(x.quantity) / parseInt(x.unitPerPack));
                                    x.quantity = parseInt(parseInt(x.quantity) % parseInt(x.unitPerPack));

                                });
                            }
                            root.$swal({
                                title: root.$t('AddSale.Error'),
                                text: root.$t('AddSale.SomethingWrong'),
                                type: 'error',
                                confirmButtonClass: "btn btn-danger",
                                icon: 'error',
                                timer: 1500,
                                timerProgressBar: true,
                            });
                        }
                    })
                    .catch(error => {
                        console.log(error)
                        if (localStorage.getItem('IsMultiUnit') == 'true') {
                            root.sale.saleItems.forEach(function (x) {

                                x.highQty = parseInt(parseInt(x.quantity) / parseInt(x.unitPerPack));
                                x.quantity = parseInt(parseInt(x.quantity) % parseInt(x.unitPerPack));

                            });
                        }
                        root.$swal.fire(
                            {
                                type: 'error',
                                icon: 'error',
                                title: error.response.data,
                                text: error.response.data,
                                confirmButtonClass: "btn btn-danger",
                                showConfirmButton: true,
                                timer: 5000,
                                timerProgressBar: true,
                            });

                        root.loading = false
                    });

            },

            goToSale: function () {
                if (this.isValid('CanViewHoldInvoices') || this.isValid('CanViewPaidInvoices') || this.isValid('CanViewCreditInvoices')) {
                    this.$router.push('/Sale');

                }
                else {
                    this.$router.go();
                }

            },

            GetUserDefineFlow: function () {
                var root = this;

                if (localStorage.getItem('quotationToSaleOrder') == undefined) {
                    root.$https.get('/Company/UserDefineFlowEdit?companyId=' + localStorage.getItem('CompanyID'), { headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` } })
                        .then(function (response) {
                            if (response.data != null) {
                                localStorage.setItem('quotationToSaleOrder', response.data.quotationToSaleOrder);
                                localStorage.setItem('quotationToSaleInvoice', response.data.quotationToSaleInvoice);
                                localStorage.setItem('partiallyQuotation', response.data.partiallyQuotation);
                                localStorage.setItem('partiallySaleOrder', response.data.partiallySaleOrder);

                                root.saleOrder = localStorage.getItem('quotationToSaleInvoice') == 'true' ? true : false;
                            }
                            else {
                                console.log("error: something wrong from db.");
                            }
                        },
                            function (error) {
                                console.log(error);
                            });
                }
                else {
                    this.saleOrder = localStorage.getItem('quotationToSaleInvoice') == 'true' ? true : false;

                }


            }


        },
        created: function () {
            this.GetHeaderDetail();

            this.$emit('input', this.$route.name);

            this.saleDefaultVat = localStorage.getItem('SaleDefaultVat');
            //this.$route.query.data.isDuplicate
            if (this.$route.query.data != undefined) {
                var data = this.$route.query.data;
                if (!data.isDuplicate) {
                    this.sale.id = data.id;
                    this.sale.saleOrderId = data.saleOrderId;
                    this.sale.quotationId = data.quotationId;
                    this.sale.registrationNo = data.registrationNo;
                }

                this.sale.date = moment().format("LLL");
                this.sale.isDuplicate = data.isDuplicate;
                this.sale.invoiceType = data.invoiceType;
                this.sale.cashCustomer = data.cashCustomer;
                this.sale.dueDate = moment().format("LLL");
                this.sale.mobile = data.mobile;
                this.sale.email = data.email;
                this.sale.isWarranty = data.isWarranty;
                this.sale.cashCustomerId = data.cashCustomerId;
                this.sale.customerAddressWalkIn = data.customerAddressWalkIn;
                this.sale.code = data.code;
                this.sale.areaId = data.areaId;
                this.sale.employeeId = data.employeeId;
                this.sale.isCredit = data.isCredit;
                this.paymentMethod = data.isCredit ? 'Credit' : 'Cash';
                this.sale.customerId = data.customerId;
                this.sale.wareHouseId = data.wareHouseId;
                this.sale.saleItems = data.saleItems;
                this.sale.taxMethod = data.taxMethod;
                this.sale.discount = data.discount;
                this.sale.taxRateId = data.taxRateId;
                this.sale.attachmentList = data.attachmentList;
                this.sale.paymentTypes = data.paymentTypes;
                

                if (localStorage.getItem('IsMultiUnit') == 'true' && localStorage.getItem('decimalQuantity') == 'true') {
                    this.sale.saleItems.forEach(function (x) {

                        x.highQty = parseInt(parseFloat(x.quantity) / parseFloat(x.product.unitPerPack));
                        x.quantity = parseFloat(parseFloat(x.quantity) % parseFloat(x.product.unitPerPack)).toFixed(3).slice(0, -1);
                        x.unitPerPack = x.product.unitPerPack;
                    });
                }
                if (localStorage.getItem('IsMultiUnit') == 'true' && localStorage.getItem('decimalQuantity') != 'true') {
                    this.sale.saleItems.forEach(function (x) {

                        x.highQty = parseInt(parseInt(x.quantity) / parseInt(x.product.unitPerPack));
                        x.quantity = parseInt(parseInt(x.quantity) % parseInt(x.product.unitPerPack));
                        x.unitPerPack = x.product.unitPerPack;
                    });
                }
                this.sale.salePayment = {
                    dueAmount: 0,
                    received: 0,
                    balance: 0,
                    change: 0,
                    paymentTypes: [],
                    paymentType: 'Cash',
                    paymentName: 'Cash',
                    paymentOptionId: '',
                };
            }
            else {
                this.sale.wareHouseId = localStorage.getItem('WareHouseId');
                this.sale.taxRateId = localStorage.getItem('TaxRateId');
                this.sale.taxMethod = localStorage.getItem('taxMethod');
            }

            if (this.isValid('CashInvoicesForCustomer') && !this.isValid('CashInvoicesForWalkIn')) {
                this.sale.isCashInvoicesForCustomer = true;
            }

            this.GetUserDefineFlow();
        },

        mounted: function () {
            this.priceType = this.priceoptions.find(option => option.id === 1);
            this.overWrite = localStorage.getItem('overWrite') == 'true' ? true : false;
            this.sale.colorVariants = localStorage.getItem('ColorVariants') == 'true' ? true : false,

                this.BusinessLogo = localStorage.getItem('BusinessLogo');
            this.BusinessNameArabic = localStorage.getItem('BusinessNameArabic');
            this.BusinessNameEnglish = localStorage.getItem('BusinessNameEnglish');
            this.BusinessTypeArabic = localStorage.getItem('BusinessTypeArabic');
            this.BusinessTypeEnglish = localStorage.getItem('BusinessTypeEnglish');
            this.CompanyNameArabic = localStorage.getItem('CompanyNameArabic');
            this.CompanyNameEnglish = localStorage.getItem('CompanyNameEnglish');
            this.isFifo = localStorage.getItem('fIFO') == 'true' ? true : false;
            var batch = localStorage.getItem('openBatch')
            if (batch != undefined && batch != null && batch != "") {
                this.openBatch = batch
            }
            else {
                this.openBatch = 1
            }
            this.saleOrderPerm = localStorage.getItem('saleOrderPerm') == 'true' ? true : false;
            debugger;
            this.wholesalePriceActivation = localStorage.getItem('WholeSalePriceActivation') == 'true' ? true : false;
            this.autoPaymentVoucher = localStorage.getItem('AutoPaymentVoucher') == 'true' ? true : false;
            this.bankDetail = localStorage.getItem('BankDetail') == 'true' ? true : false;

            this.language = this.$i18n.locale;
            var IsDayStart = localStorage.getItem('DayStart');
            this.sale.dayStart = IsDayStart == 'false' ? false : true;
            var IsExpenseDay = localStorage.getItem('IsExpenseDay');
            var IsDayStartOn = localStorage.getItem('IsDayStart');
            this.sale.counterId = localStorage.getItem('CounterId');
            this.headerFooter.returnDays = localStorage.getItem('ReturnDays');
            this.isForMedical = localStorage.getItem('isForMedical');
            this.headerFooter.footerEn = localStorage.getItem('TermsInEng');
            this.headerFooter.footerAr = localStorage.getItem('TermsInAr');
            this.headerFooter.printSizeA4 = localStorage.getItem('PrintSizeA4');
            this.printTemplate = localStorage.getItem('PrintTemplate');
            this.printSize = localStorage.getItem('PrintSizeA4');


            if (IsDayStart != 'true') {
                this.isDayAlreadyStart = true;
                this.language = this.$i18n.locale;
                this.getBank();

                this.getCurrency();
                this.isArea = localStorage.getItem('IsArea');
                this.currency = localStorage.getItem('currency');
                this.isMultiUnit = localStorage.getItem('IsMultiUnit');
                this.isRaw = localStorage.getItem('IsProduction');
                if (this.$route.query.data == undefined) {
                    if ((this.$i18n.locale == 'en' || this.isLeftToRight())) {
                        this.sale.cashCustomer = "Walk-In";
                    }
                    else {
                        this.sale.cashCustomer = "ادخل";
                    }

                    this.sale.dueDate = moment().format("LLL");
                }

                if (this.$route.query.data == undefined) {
                    this.sale.date = moment().format('LLL');
                }
                this.AutoIncrementCode();
                if (this.$route.query.data != undefined) {
                    this.warehouse = this.$route.query.data;
                }

                if (this.$route.query.mobiledata != undefined) {
                    this.sale.date = this.$route.query.mobiledata.orderDate;
                }
            }
            else {

                if (IsExpenseDay == 'true') {
                    this.isDayAlreadyStart = false;
                }
                else {
                    this.UserID = localStorage.getItem('UserID');
                    this.employeeId = localStorage.getItem('EmployeeId');
                    if (IsDayStartOn == 'true') {
                        var root = this;
                        this.isDayAlreadyStart = true;
                        root.getBank();

                        root.getCurrency();
                        root.isArea = localStorage.getItem('IsArea');
                        root.currency = localStorage.getItem('currency');
                        root.isMultiUnit = localStorage.getItem('IsMultiUnit');
                        root.isRaw = localStorage.getItem('IsProduction');
                        if (root.$route.query.data == undefined) {
                            if ((root.$i18n.locale == 'en' || root.isLeftToRight())) {
                                if (root.isValid('CashInvoices')) {
                                    root.isCredit(root.toggleCash);
                                    root.sale.cashCustomer = "Walk-In";
                                }
                                else if (root.isValid('CreditInvoices')) {
                                    root.isCredit(root.toggleCredit);
                                    //root.paymentMethod = 'Credit';
                                }
                            }
                            else {
                                if (root.isValid('CashInvoices')) {
                                    //root.paymentMethod = 'Cash';
                                    root.isCredit(root.toggleCash);
                                    root.sale.cashCustomer = "ادخل";
                                }
                                else if (root.isValid('CreditInvoices')) {
                                    root.isCredit(root.toggleCredit);
                                    //root.paymentMethod = 'Credit';
                                }
                                //root.sale.cashCustomer = "";
                            }
                            root.sale.dueDate = moment().format("LLL");
                        }
                        if (this.$route.query.data == undefined) {
                            this.sale.date = moment().format('LLL');
                        }
                        root.AutoIncrementCode();
                        if (root.$route.query.data != undefined) {
                            root.warehouse = root.$route.query.data;
                        }

                        if (root.$route.query.mobiledata != undefined) {
                            root.sale.date = root.$route.query.mobiledata.orderDate;
                        }
                    }
                    else {
                        this.isDayAlreadyStart = false;
                    }
                }

            }
            this.sale.barCode = Math.floor(Math.random() * 100000000000);
        },
    };
</script>
<style scoped>
    
    .title_heading {
        font-weight: 600;
    }

    .bg_color {
        background-color: #dee9fe;
        border: 1px solid rgb(49 120 246);
    }

    .vue-radio-button {
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
    }

    .icon {
        object-fit: contain;
    }

    .v-radio-button-active {
        background-color: #b6d7ff73 !important;
    }

    .title {
        font-size: 11px;
        margin-left: -10px;
    }


    .pointer-event-remove {
        pointer-events: none;
    }
</style>

